export default __webpack_public_path__ + "static/media/cofounders.ffd8554f.jpeg";